<script setup lang="ts">
import SecretManagementPanel from '../components/SecretManagementPanel.vue';
</script>

<template>
  <main class="vb-admin-content">
    <SecretManagementPanel admin />
  </main>
</template>
